<app-header [active]="3" [circuito]="circuito"></app-header>
<br>
<div class="container">
  <div class="row">
    <br>
    <div class="col-12">
      <div class="card">
        <div class="card-header" style="font-size: 16px">
          Circuito
        </div>
        <div class="card-body">
          <div>
            <strong>Nombre:</strong>
            <label style="tab-size: 20px"> {{circuito.nombre}}</label>
          </div>
          <div>
            <strong>Codigo:</strong>
            <label style="tab-size: 20px"> {{circuito.guid}}</label>
          </div>
        </div>
      </div>
      <br>
      <div class="card">
        <div class="card-header" style="font-size:16px;display:flex;justify-content:space-between;align-items:center;">
          <span>Facturación</span>
          <span class="badge" [ngClass]="billingBadgeClass" *ngIf="billingStatus">{{billingLabel}}
            <span *ngIf="billingStatus==='TRIAL' && daysUntilExpiry!==null"> · {{daysUntilExpiry}}d</span>
            <span *ngIf="billingStatus==='ACTIVE' && billingCycle"> · {{billingCycle}}</span>
            <span *ngIf="billingStatus==='ACTIVE' && paymentProvider"> · {{paymentProvider}}</span>
            <span *ngIf="billingStatus==='ACTIVE' && subscriptionExpiresAt"> · Vence {{formattedExpiresAt}}</span>
            <span *ngIf="billingStatus==='LIFETIME'"> · Vitalicia</span>
          </span>
        </div>
        <div class="card-body">
          <div *ngIf="billingLoading">Cargando facturación...</div>
          <div *ngIf="billingError" class="text-danger" style="font-size:13px;">{{billingError}} <a (click)="loadBillingStatus()" style="cursor:pointer;text-decoration:underline;margin-left:8px;">Reintentar</a></div>
          <div *ngIf="!billingLoading && !billingError">
            <p *ngIf="planName$ | async as planName" style="margin:0 0 8px;color:#666;font-size:13px;">Plan: {{planName}}</p>
            <div *ngIf="billingStatus==='TRIAL'">
              <p style="margin:0 0 4px;color:#555;font-size:14px;">Estás en período de prueba. <span *ngIf="subscriptionExpiresAt">Vence el {{formattedExpiresAt}} ({{daysUntilExpiry}} días).</span><span *ngIf="!subscriptionExpiresAt && trialEndsAt">Vence el {{trialEndsAt | date:'dd/MM/yyyy'}} ({{trialDaysRemaining}} días).</span></p>
              <p *ngIf="billingCycle || paymentProvider" style="margin:0 0 4px;color:#666;font-size:12px;">Ciclo: {{billingCycle || '-'}} · Medio: {{paymentProvider || '-'}} · Expira: {{formattedExpiresAt}} · {{daysUntilExpiry}}d restantes</p>
              <p style="margin:0 0 12px;color:#555;font-size:13px;">Activa tu cuenta para continuar sin interrupciones.</p>
              <a routerLink="/pago" class="btn btn-primary" style="font-size:14px;">Reactivar suscripción</a>
            </div>
            <div *ngIf="billingStatus==='EXPIRED'">
              <p style="margin:0 0 4px;color:#a94442;font-weight:bold;font-size:14px;">Período finalizado.</p>
              <p *ngIf="subscriptionExpiresAt" style="margin:0 0 4px;color:#666;font-size:12px;">Venció el {{formattedExpiresAt}} · Ciclo: {{billingCycle || '-'}} · Medio: {{paymentProvider || '-'}} · {{daysUntilExpiry}}d</p>
              <p style="margin:0 0 12px;color:#555;font-size:13px;">Tu cuenta está pausada. Reactívala para restaurar el servicio.</p>
              <a routerLink="/pago" class="btn btn-primary" style="font-size:14px;">Reactivar suscripción</a>
            </div>
            <div *ngIf="billingStatus==='ACTIVE'">
              <p style="margin:0 0 4px;color:#3c763d;font-size:14px;"><span style="font-weight:bold;">✓</span> Suscripción activa — tu cuenta está al día.</p>
              <p style="margin:0 0 4px;color:#666;font-size:12px;">Ciclo: {{billingCycle || '-'}} · Medio: {{paymentProvider || '-'}} · Vence: {{formattedExpiresAt}} · {{daysUntilExpiry}}d restantes</p>
              <p style="margin:0 0 12px;color:#666;font-size:13px;">Puedes cambiar de plan o gestionar tu suscripción.</p>
              <a *ngIf="showRenewCTA" routerLink="/pago" class="btn btn-primary" style="font-size:14px;">Reactivar suscripción</a>
              <span *ngIf="!showRenewCTA" class="badge badge-light" style="font-size:12px;">Al día — renueva dentro de {{daysUntilExpiry}} días</span>
            </div>
            <div *ngIf="billingStatus==='LIFETIME'">
              <p style="margin:0 0 4px;color:#31708f;font-size:14px;"><span style="font-weight:bold;">∞</span> Suscripción vitalicia</p>
              <p style="margin:0 0 4px;color:#666;font-size:12px;">Sin vencimiento · Ciclo: {{billingCycle || 'vitalicia'}} · Medio: {{paymentProvider || '-'}}</p>
              <p style="margin:0 0 12px;color:#666;font-size:13px;">Tu cuenta no vence.</p>
            </div>
            <div *ngIf="!billingStatus">
              <p style="color:#666;font-size:13px;">No se pudo determinar el estado de facturación.</p>
              <a routerLink="/pago" class="btn btn-outline-dark" style="font-size:14px;">Ir a pagos</a>
            </div>
          </div>
        </div>
      </div>
      <br>
      <div class="card">
        <div class="card-header" style="font-size: 16px">
          Grupos <a class="btn btn-outline-dark add-btn" (click)="crearGrupo()"
                    style="float: right; font-size: 16px; line-height: 16px;"> Agregar grupo</a>
        </div>
        <div class="card-body">
          <table class="table table-sm">
            <thead style="border: none !important;">
            <tr>
              <th scope="col">Nombre</th>
              <th scope="col" style="text-align: right">Opciones</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let grupo of grupos; let j = index">
              <td>{{grupo.nombre}}</td>
              <td style="text-align: right" class="cell-options">
                <div class="btn-group">
                  <div class="btn-group" ngbDropdown role="group" aria-label="Button group with nested dropdown">
                    <a class="row-option-button" ngbDropdownToggle (click)="showOptionesRow(grupo)">
                      <img src="../../../assets/img/captarmedia-estado-settings.png" class="row-option-icon">
                    </a>
                    <div class="dropdown-menu" ngbDropdownMenu>
                      <a class="dropdown-item" (click)="editarGrupo(grupo)">Editar</a>
                      <a class="dropdown-item" (click)="eliminarGrupo(grupo)">Eliminar</a>
                    </div>
                  </div>
                </div>
                <div ngbDropdown class="btn-group dropleft">
                  <div class="dropdown-menu">
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <br>
      <div class="card">
        <div class="card-header" style="font-size: 16px">
          Equipos
          <span *ngIf="(screensInUse$ | async) !== null && (maxScreens$ | async) !== null" class="screen-counter" style="font-size: 13px; color: #666; margin-left: 8px;">Pantallas {{screensInUse$ | async}}/{{maxScreens$ | async}}</span>
          <a routerLink="/vincular-tv" class="btn btn-outline-dark add-btn" style="float: right; font-size: 16px; line-height: 16px; margin-left: 8px;">Vincular TV</a>
          <button type="button" class="btn btn-outline-dark add-btn equipos-add-btn" (click)="crearEquipo()" [disabled]="isAtCap$ | async"
                     style="float: right; font-size: 16px; line-height: 16px;">Agregar equipo</button>
        </div>
        <div class="card-body">
          <div *ngIf="isAtCap$ | async" class="screen-cap-notice alert alert-warning" style="font-size: 13px;">Has alcanzado el límite de pantallas de tu plan. <a routerLink="/pago">Mejorar plan</a></div>
          <table class="table table-sm">
            <thead>
            <tr>
              <th scope="col">Equipo</th>
              <th scope="col" style="text-align: right">Key</th>
              <th scope="col" style="text-align: right">Grupo</th>
              <th scope="col" style="text-align: right">Estado</th>
              <th scope="col" style="text-align: right">Opciones</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let equipo of equipos; let j = index">
              <td>{{equipo.nombre}}</td>
              <td style="text-align: right">{{equipo.guid}}</td>
              <td style="text-align: right">{{getgrupo(grupos,equipo) && getgrupo(grupos,equipo).nombre}}</td>
              <td style="text-align: right">
                <span *ngIf="isVinculada(equipo) === true" class="badge badge-success" title="Este equipo ya reportó actividad (TV vinculado)">Vinculada</span>
                <span *ngIf="isVinculada(equipo) === false" class="badge badge-secondary" title="Equipo creado pero sin reporte: pendiente de Vincular TV">Sin vincular</span>
                <span *ngIf="isVinculada(equipo) === null" style="color:#999;">—</span>
              </td>
              <td style="text-align: right" class="cell-options">
                <div class="btn-group">
                  <div class="btn-group" ngbDropdown role="group">
                    <a ngbDropdownToggle (click)="showOptionesRow(equipo)">
                      <img src="../../../assets/img/captarmedia-estado-settings.png" class="row-option-icon">
                    </a>
                    <div class="dropdown-menu" ngbDropdownMenu>
                      <a class="dropdown-item" (click)="editarEquipo(j,equipo)">Editar</a>
                      <a class="dropdown-item" (click)="eliminarEquipo(j,equipo)">Eliminar</a>
                    </div>
                  </div>
                </div>
                <div ngbDropdown class="btn-group dropleft">
                  <div class="dropdown-menu">
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <br>
      <div class="card" *ngIf="isAdmin">
        <div class="card-header" style="font-size: 16px">
          Código de administrador
        </div>
        <div class="card-body">
          <div *ngIf="adminCodeLoading">Cargando código...</div>
          <div *ngIf="!adminCodeLoading && adminStaticCode" style="display:flex; align-items:center; gap:10px;">
            <span *ngIf="!adminCodeVisible" style="font-family: monospace; font-size: 22px; letter-spacing: 4px; font-weight: bold;">{{ getMaskedAdminCode() }}</span>
            <span *ngIf="adminCodeVisible" style="font-family: monospace; font-size: 22px; letter-spacing: 4px; font-weight: bold;">{{adminStaticCode}}</span>
            <button type="button" class="btn btn-outline-dark" style="font-size: 12px; line-height: 12px; padding: 6px 10px; display:flex; align-items:center; justify-content:center;" (click)="toggleAdminCodeVisibility()" [attr.aria-label]="adminCodeVisible ? 'Ocultar código' : 'Mostrar código'" [attr.title]="adminCodeVisible ? 'Ocultar código' : 'Mostrar código'">
              <span *ngIf="!adminCodeVisible"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg></span>
              <span *ngIf="adminCodeVisible"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.53 9.53A3 3 0 0 0 12 15a3 3 0 0 0 2.47-5.47"/><line x1="1" y1="1" x2="23" y2="23"/></svg></span>
            </button>
            <input #adminCodeInput type="text" [value]="adminStaticCode" readonly style="position:absolute; left:-9999px;">
            <button class="btn btn-outline-dark" style="font-size: 12px; line-height: 12px; padding: 6px 12px;" (click)="copiarAdminCode(adminCodeInput)">{{ adminCodeCopied ? 'Copiado' : 'Copiar' }}</button>
          </div>
          <div *ngIf="!adminCodeLoading && !adminStaticCode" style="color:#666; font-size:13px;">No se pudo cargar el código.</div>
          <div style="margin-top:8px; color:#666; font-size:13px;">Este código es único y no expira. Guárdalo en lugar seguro.</div>
        </div>
      </div>
      <br *ngIf="isAdmin">
      <div class="card" *ngIf="isAdmin">
        <div class="card-header" style="font-size: 16px">
          Roles
          <a class="btn btn-outline-dark add-btn" (click)="abrirInviteModal()"
             style="float: right; font-size: 16px; line-height: 16px;"> Invitar</a>
        </div>
        <div class="card-body">
          <table class="table table-sm">
            <thead>
            <tr>
              <th scope="col">Usuario</th>
              <th scope="col" style="text-align: right">Rol</th>
              <th scope="col" style="text-align: right">Opciones</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let user of usuarios; let j = index">
              <td>{{ user.name || user.email }}<div *ngIf="user.name" style="font-size: 12px; color: #666;">{{ user.email }}</div></td>
              <td style="text-align: right">{{user.role}}</td>
              <td style="text-align: right">
                <a class="btn btn-outline-dark" (click)="abrirEditarUsuario(user)"
                   style="font-size: 12px; line-height: 12px; padding: 4px 8px; margin-right: 4px;">Editar</a>
                <a class="btn btn-outline-dark" *ngIf="!esUsuarioActual(user)" (click)="toggleUserLockout(user)"
                   style="font-size: 12px; line-height: 12px; padding: 4px 8px; margin-right: 4px;">{{ user.lockout ? 'Desbloquear' : 'Bloquear' }}</a>
                <a class="btn btn-outline-dark" *ngIf="!esUsuarioActual(user)" (click)="abrirRecoveryModal(user)"
                   style="font-size: 12px; line-height: 12px; padding: 4px 8px; margin-right: 4px;">Recuperar</a>
                <button type="button" class="btn" [class.btn-primary]="!estaActivo(user)" [class.btn-secondary]="estaActivo(user)" *ngIf="!esUsuarioActual(user)" [disabled]="estaActivo(user)" (click)="abrirActivarModal(user)" style="font-size: 12px; line-height: 12px; padding: 4px 8px; border: 1px solid #343a40;">Activar</button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <br>
  <div style="height: 50px; width: 100%"></div>
</div>

<app-invite-modal *ngIf="showInviteModal" (onClose)="cerrarInviteModal()"></app-invite-modal>

<app-recovery-link-modal *ngIf="showRecoveryModal" [email]="recoveryTarget && recoveryTarget.email" (onClose)="cerrarRecoveryModal()"></app-recovery-link-modal>

<app-edit-user-modal *ngIf="showEditUserModal" [user]="editUserTarget" [canEditRole]="puedeEditarRol(editUserTarget)" (onClose)="cerrarEditarUsuario()" (onSave)="guardarEditarUsuario($event)"></app-edit-user-modal>

<app-confirm-modal *ngIf="showActivateModal"
                   titulo="Activar usuario"
                   [mensaje]="activateMensaje"
                   botonConfirmar="Activar"
                   botonCancelar="Cancelar"
                   (onConfirm)="confirmarActivacion()"
                   (onCancel)="cerrarActivarModal()"
                   (onClose)="cerrarActivarModal()">
</app-confirm-modal>

<app-modal-grupo *ngIf="showmodalEditar" (onclose)="showmodalEditar = false;" [item]="item"
                 (onsuccess)="successEditar($event)"></app-modal-grupo>
<app-modal-grupo *ngIf="showcreargrupo" (onclose)="showcreargrupo=false" [item]="item"
                 (onsuccess)="successcrearGrupo($event)"></app-modal-grupo>

<app-modal-equipo *ngIf="showcrearequipo" (onclose)="showcrearequipo = false" [item]="item" [grupos]="grupos"
                  (onsuccess)="successCrearEquipo($event)"></app-modal-equipo>
<app-modal-equipo *ngIf="showeditarequipo" (onclose)="showeditarequipo = false" [item]="item" [grupos]="grupos"
                  (onsuccess)="successEditarEquipo($event)"></app-modal-equipo>



// WEBPACK FOOTER //
// ./src/app/admin/setting/setting.component.html